import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO, BreadcrumbSchema } from '../components/SEO';
import { CheckCircle2 } from 'lucide-react';

export default function BookCallPage() {
  const breadcrumbs = [
    { name: 'Home', path: '/' },
    { name: 'Book Strategy Call', path: '/book-call' }
  ];

  return (
    <div className="min-h-screen" data-testid="book-call-page">
      <SEO 
        title="Book a Free Strategy Call - RenoNovo"
        description="Schedule your free strategy call with RenoNovo. Learn how we can help your home service business grow with exclusive appointments. No obligation."
        keywords="book strategy call, contractor consultation, appointment generation consultation, RenoNovo consultation"
        canonical="/book-call"
      />
      <BreadcrumbSchema items={breadcrumbs} />
      <Header />
      <main>
        {/* Hero Section */}
        <section className="pt-32 pb-8 md:pt-40 md:pb-12 bg-[#f8fafc]">
          <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 text-center">
            <p className="text-sm tracking-wide uppercase font-semibold text-[#2563eb] mb-4">
              Get Started
            </p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[#0f172a] tracking-tight leading-tight mb-6">
              Book Your Free Strategy Call
            </h1>
            <p className="text-lg text-[#64748b] leading-relaxed max-w-2xl mx-auto">
              Fill out the form below and our team will reach out to schedule your 
              complimentary consultation. No obligation — just valuable insights for your business.
            </p>
          </div>
        </section>

        {/* Form Section */}
        <section className="py-12 md:py-16">
          <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
              {/* Benefits Sidebar */}
              <div className="lg:col-span-1 space-y-8">
                <div>
                  <h2 className="text-2xl font-bold text-[#0f172a] mb-4">What You'll Get</h2>
                  <p className="text-[#64748b]">
                    Our strategy calls are designed to give you actionable insights 
                    for growing your home service business.
                  </p>
                </div>

                <div className="space-y-4">
                  {[
                    'Free consultation',
                    'Custom growth strategy for your business',
                    'Territory availability check',
                    'ROI projection for your market',
                    'No obligation to sign up',
                  ].map((item, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <CheckCircle2 className="w-5 h-5 text-[#2563eb] flex-shrink-0 mt-0.5" />
                      <span className="text-[#0f172a]">{item}</span>
                    </div>
                  ))}
                </div>

                <div className="bg-[#f8fafc] p-6 rounded-sm border border-[#e2e8f0]">
                  <p className="text-sm text-[#64748b] mb-2">Have questions first?</p>
                  <a 
                    href="tel:+13212102777" 
                    className="text-[#2563eb] font-semibold text-lg hover:underline"
                  >
                    Call (321) 210-2777
                  </a>
                </div>
              </div>

              {/* Embedded Form */}
              <div className="lg:col-span-2">
                <div className="bg-white rounded-sm shadow-[0_4px_20px_rgba(15,23,42,0.08)] overflow-hidden">
                  <iframe
                    src="https://link.msgsndr.com/widget/form/5Lrly5d1gsvY2agn8U2l"
                    style={{ width: '100%', height: '1000px', border: 'none' }}
                    id="strategy-call-form"
                    data-testid="strategy-call-form"
                    title="Book Strategy Call Form"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
